import { FunctionComponent } from 'react';

import PleaseWaitOverlay from 'components/PleaseWaitOverlay';
import { useStatusContext } from 'pages/Status/context';

import Generic from '../../../Generic';

const SignDocuments: FunctionComponent = () => {
  const { credit } = useStatusContext();
  if (!credit) return null;
  const { xstatus } = credit;
  if (!xstatus || xstatus !== 'AG_AUTO_ACCEPTED') return <Generic.Referred />;
  return (
    <PleaseWaitOverlay
      icon="check-circle-color"
      iconClassName="text-red-200 mb-4"
      title="To complete your finance application, you need to sign the lender's documents"
      labelLine1="Our lender, Propensio Finance, will have sent you an email containing a link to follow and sign your documents. Please use that link to continue."
      labelLine2="If you have not received that email, you can reach out to Propensio directly on 01709 808 990"
    />
  );
};

export default SignDocuments;
